var exports = {
  "kL": "x936d19a0--2d47c5--container",
  "Hw": "x936d19a0--2d47c5--mobile",
};

module.exports = exports;
